import LogRocket from "logrocket";

// @ts-expect-error LogRocket React integration types are not available
//
// `@types/logrocket-react` is an unmaintained package that for some reason has a dependency on `logrocket` version `"1.0.1"`,
// which imports a second ancient version of the SDK (current is `10.x`). I will update the comment to reflect this.
import setupLogRocketReact from "logrocket-react";

import { useEffect, useRef } from "react";
import $api from "./queries/openapi";

export default function LogRocketIntegration({ appId }: { appId: string }) {
  useEffect(() => {
    LogRocket.init(appId);
    setupLogRocketReact(LogRocket);
  }, [appId]);

  // User identification
  const session = useRef<{ userId?: string }>({});
  const userQuery = $api.useQuery("get", "/api/user");
  const currentUser = userQuery.error ? null : userQuery.data!; // after logout query will return 401 but `user` will remain set
  useEffect(() => {
    if (
      session.current.userId &&
      (!currentUser || currentUser.id !== session.current.userId)
    ) {
      // Current session has a user associated, but current user is different (incl. null/logout), start a new session.
      LogRocket.startNewSession();
      session.current = {};
    }

    if (!session.current.userId && currentUser) {
      // Current session does not have a user associated, but current user is logged in, identify the user.
      LogRocket.identify(currentUser.id, {
        name: currentUser.display_name,
        email: currentUser.email,
      });
      session.current.userId = currentUser.id;
    }
  }, [currentUser]);

  return null;
}
